// What a fill's source opens on this machine: `camera` is this machine's camera, a file its local copy.
import { isShaderSource } from '~/lib/shaders'
import { CAMERA_SOURCE, isSourceFill } from '~/lib/sourceFill'
import { resolveSavedFile } from './files'
import { isFileSource } from './ids'
import { isKnown } from './videoPool'

/** The runtime source id a fill source shows (a device id, 'screen', `file:<id>`); null for a shader or nothing to open. */
export const resolveFillSource = (source, { device, bags } = {}) => {
	if (source === CAMERA_SOURCE) return device || null
	if (source === 'screen') return 'screen'
	if (isFileSource(source)) return resolveSavedFile(source, bags?.[source]) ?? (isKnown(source) ? source : null)
	return null
}

/** Each picture source the fills in `objects` use, once, in tree order: `{ source, id }` with `id` its runtime id (null when it opens nothing here). Shaders are not pictures. */
export const fillPictures = (objects, { device, bags } = {}) => {
	const out = new Map()
	const walk = ids => {
		for (const id of ids ?? []) {
			const obj = objects?.[id]
			if (!obj) continue
			const fill = obj.fill
			if (isSourceFill(fill) && !isShaderSource(fill.source) && !out.has(fill.source))
				out.set(fill.source, { source: fill.source, id: resolveFillSource(fill.source, { device, bags }) })
			walk(obj.children)
		}
	}
	walk(objects?.root?.children)
	return [...out.values()]
}
